// This file is auto-generated by @hey-api/openapi-ts

import type { GetArticleBySlugResponse } from './types.gen';

const contentTokenSchemaResponseTransformer = (data: any) => {
  if (data.children) {
    data.children = data.children.map((item: any) => {
      return contentTokenSchemaResponseTransformer(item);
    });
  }
  return data;
};

const articleDetailsSchemaResponseTransformer = (data: any) => {
  if (data.contents_tokens) {
    data.contents_tokens = data.contents_tokens.map((item: any) => {
      return contentTokenSchemaResponseTransformer(item);
    });
  }
  if (data.created_at) {
    data.created_at = new Date(data.created_at);
  }
  if (data.published_at) {
    data.published_at = new Date(data.published_at);
  }
  if (data.updated_at) {
    data.updated_at = new Date(data.updated_at);
  }
  return data;
};

const citySearchWidgetSchemaResponseTransformer = (data: any) => {
  if (data.date_end) {
    data.date_end = new Date(data.date_end);
  }
  if (data.date_start) {
    data.date_start = new Date(data.date_start);
  }
  return data;
};

const relatedArticleSchemaResponseTransformer = (data: any) => {
  if (data.created_at) {
    data.created_at = new Date(data.created_at);
  }
  if (data.published_at) {
    data.published_at = new Date(data.published_at);
  }
  if (data.updated_at) {
    data.updated_at = new Date(data.updated_at);
  }
  return data;
};

const articleResponseSchemaResponseTransformer = (data: any) => {
  if (data.article_details) {
    data.article_details = articleDetailsSchemaResponseTransformer(data.article_details);
  }
  if (data.city_exps_search_widget) {
    data.city_exps_search_widget = citySearchWidgetSchemaResponseTransformer(data.city_exps_search_widget);
  }
  if (data.related_articles) {
    data.related_articles = data.related_articles.map((item: any) => {
      return relatedArticleSchemaResponseTransformer(item);
    });
  }
  return data;
};

export const getArticleBySlugResponseTransformer = async (data: any): Promise<GetArticleBySlugResponse> => {
  data = articleResponseSchemaResponseTransformer(data);
  return data;
};
